module.exports = __webpack_public_path__ + "static/img/ios_uk.81db348c.png";